import type { FC } from 'react'
import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import { data } from './data'

const Methodology: FC = () => {
  return (
    <SectionBaseStyled variant="centered">
      <StyledSectionCopy>
        <CopyTextBase>
          <CopyText.Overline variant="h5" tag="h4">
            {data.heading}
          </CopyText.Overline>
          <Ul>
            {data.list.map((text) => {
              return <Li key={text}>{text}</Li>
            })}
          </Ul>
        </CopyTextBase>
      </StyledSectionCopy>
    </SectionBaseStyled>
  )
}

const SectionBaseStyled = styled(SectionBase)`
  ${Section.Wrapper} {
    padding: 0 auto;
    ${({ theme }) => theme.breakpoints.up(`md`)} {
      padding-bottom: 80px;
    }
  }
`

const Ul = styled.ul`
  margin-top: 40px;
  padding: inherit;
  padding-left: 24px;
  padding-right: 16px;
  li {
    :not(:first-of-type) {
      margin: 28px auto;
    }
  }
  ${({ theme }) => theme.breakpoints.up(`md`)} {
    columns: 2;
    gap: 80px;
    li {
      margin: 0;
      break-inside: avoid-column;
    }
  }
`

const Li = styled.li`
  ${({ theme }) => theme.typography.pSmall}
  color: ${({ theme }) => theme.palette.twilio.gray[80]};
`

const StyledSectionCopy = styled(Section.Copy)`
  width: 100%;
  padding: auto 80px;
`

export default Methodology
